import cookie from "js-cookie";

// Set in Cookie
export const setCookie = (key, value) => {
  if (window !== "undefiend") {
    cookie.set(key, value, {
      // 1 Day
      expires: 1,
    });
  }
};
// remove from cookie
export const removeCookie = (key) => {
  if (window !== "undefined") {
    cookie.remove(key, {
      expires: 1,
    });
  }
};

// Get from cookie such as stored token
// Will be useful when we need to make request to server with token
export const getCookie = (key) => {
  if (window !== "undefined") {
    return cookie.get(key);
  }
};

// Set in localstorage
export const setLocalStorage = (key, value) => {
  if (window !== "undefined") {
    if (value === undefined || value === null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }
};

// Remove from localstorage
export const removeLocalStorage = (key) => {
  if (window !== "undefined") {
    localStorage.removeItem(key);
  }
};

// Get from localstorage
export const getLocalStorage = (key) => {
  if (window !== "undefined") {
    const value = localStorage.getItem(key);
    if (value === "undefined" || value === "null" || value === null || value === undefined) {
      return null;
    }
    try {
      return JSON.parse(value);
    } catch (e) {
      // If it's not JSON, return the raw value if it's not truthy-looking garbage
      if (value && value !== "" && value !== "null" && value !== "undefined") {
        return value;
      }
      return null;
    }
  }
  return null;
};

// Auth enticate user by passing data to cookie and localstorage during signin
export const authenticate = (response, next) => {
  setCookie("token", response.access_token);
  if (response.refresh_token) {
    setCookie("refresh_token", response.refresh_token);
  }
  // setLocalStorage("user", {
  //   ...response.user_details,
  //   access_token: undefined,
  //   refresh_token: undefined,
  // });
  next();
};

// Access user info from localstorage
export const isAuth = () => {
  if (window !== "undefined") {
    const cookieChecked = getCookie("token");
    if (cookieChecked) {
      return JSON.parse(atob(cookieChecked.split('.')[1]));
    } else {
      return false;
    }
  }
};

export const signout = (next) => {
  removeCookie("token");
  removeCookie("refresh_token");
  removeLocalStorage("user");
  removeLocalStorage("selected_company");
  removeLocalStorage("selected_process_tab");
  removeLocalStorage("selected_stage_tab");
  if (next) {
    next();
  }
};

//UTC time
export const formatDateTime = (utcString) => {
  if (!utcString) return "";

  let normalizedString = String(utcString).trim();

  // Handle formats like "2026-09-23 20:54:35.056815 +0530", "2026-09-23 20:54:35.056815+05:30", "2026-09-23", etc.
  const isoMatch = normalizedString.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d+))?)?(?:\s*([+-]\d{2}):?(\d{2})|Z)?$/
  );

  let dateObj;
  if (isoMatch) {
    const [, year, month, day, hours, minutes, seconds, fraction, tzSignHours, tzMins] = isoMatch;

    if (!hours && !minutes) {
      // Just a date: YYYY-MM-DD -> MM-DD-YYYY
      return `${month}-${day}-${year}`;
    }

    const h = hours || "00";
    const min = minutes || "00";
    const sec = seconds || "00";
    const ms = fraction ? fraction.slice(0, 3).padEnd(3, '0') : "000";

    let tzString = "";
    if (tzSignHours && tzMins !== undefined) {
      const sign = tzSignHours.startsWith("-") ? "-" : "+";
      const tzH = tzSignHours.replace(/^[+-]/, "").padStart(2, "0");
      const tzM = tzMins ? tzMins.padStart(2, "0") : "00";
      tzString = `${sign}${tzH}:${tzM}`;
    } else if (normalizedString.endsWith("Z")) {
      tzString = "Z";
    }

    const isoConstructed = `${year}-${month}-${day}T${h}:${min}:${sec}.${ms}${tzString}`;
    dateObj = new Date(isoConstructed);
  } else {
    dateObj = new Date(normalizedString);
  }

  if (isNaN(dateObj.getTime())) return utcString;

  // Format as MM-DD-YYYY HH:mm (24-hour format)
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = dateObj.getFullYear();
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');

  return `${month}-${day}-${year} ${hours}:${minutes}`;
};

// Date only (MM-DD-YYYY)
export const formatDate = (utcString) => {
  if (!utcString) return "";

  let normalizedString = String(utcString).trim();

  const isoMatch = normalizedString.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d+))?)?(?:\s*([+-]\d{2}):?(\d{2})|Z)?$/
  );

  let dateObj;
  if (isoMatch) {
    const [, year, month, day, hours, minutes, seconds, fraction, tzSignHours, tzMins] = isoMatch;

    if (!hours && !minutes) {
      return `${month}-${day}-${year}`;
    }

    const h = hours || "00";
    const min = minutes || "00";
    const sec = seconds || "00";
    const ms = fraction ? fraction.slice(0, 3).padEnd(3, '0') : "000";

    let tzString = "";
    if (tzSignHours && tzMins !== undefined) {
      const sign = tzSignHours.startsWith("-") ? "-" : "+";
      const tzH = tzSignHours.replace(/^[+-]/, "").padStart(2, "0");
      const tzM = tzMins ? tzMins.padStart(2, "0") : "00";
      tzString = `${sign}${tzH}:${tzM}`;
    } else if (normalizedString.endsWith("Z")) {
      tzString = "Z";
    }

    const isoConstructed = `${year}-${month}-${day}T${h}:${min}:${sec}.${ms}${tzString}`;
    dateObj = new Date(isoConstructed);
  } else {
    dateObj = new Date(normalizedString);
  }

  if (isNaN(dateObj.getTime())) {
    const simpleDate = normalizedString.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (simpleDate) {
      return `${simpleDate[2]}-${simpleDate[3]}-${simpleDate[1]}`;
    }
    return utcString;
  }

  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();

  return `${month}-${day}-${year}`;
};  